import axiosInstance from '../axiosInstance'
import { SiteID } from '../sites/models/site'
import { Notification, NotificationDto, notificationFromDto, NotificationID } from './models/notification'
import { Pagination } from '../common/models/pagination'

export interface NotificationSearchForm {
    perPage?: number
    page?: number
}

interface NotificationSearchParams {
    per_page?: number
    page?: number
}

export const fetch = async (siteId: SiteID, form: NotificationSearchForm): Promise<{ notifications: Notification[], pagination: Pagination }> => {
    const params: NotificationSearchParams = {}

    if (form.perPage) {
        params.per_page = form.perPage
    }

    if (form.page) {
        params.page = form.page
    }

    const response = await axiosInstance.get(`api/orgs/${siteId}/notifications`, { params })

    const data = response.data.data as NotificationDto[]

    return {
        notifications: data.map((notification) => {
            return notificationFromDto(notification)
        }),
        pagination: new Pagination(response.data.meta.pagination)
    }
}

export const readAll = async (siteId: SiteID): Promise<void> => {
    await axiosInstance.put(`api/orgs/${siteId}/notifications`)
}

export const read = async (siteId: SiteID, notificationId: NotificationID): Promise<void> => {
    await axiosInstance.put(`api/orgs/${siteId}/notifications/${notificationId}`)
}

export const save = async (siteId: SiteID, notificationId: NotificationID): Promise<void> => {
    await axiosInstance.put(`api/orgs/${siteId}/notifications/${notificationId}/save`)
}

export const done = async (siteId: SiteID, notificationId: NotificationID): Promise<void> => {
    await axiosInstance.put(`api/orgs/${siteId}/notifications/${notificationId}/done`)
}